import AxiosHelper from '../api/AxiosHelper';
import useAuth from './useAuth';
import Constants from './../utils/constants';

const useRefreshToken = () => {
    const { setAuth, setReady, setRole, setPanel } = useAuth();

    const refresh = () => {
        AxiosHelper.refresh().then((res) => {
            if (res.status === 200) {
                const auth = res.data;
                const role = auth.role;
                setAuth(prev => { return {...prev, ...auth } });
                
                // The panel follows from the role type, so it is stored rather than
                // read back from localStorage: a stale value left by a previous
                // session on this browser used to override the type entirely.
                switch(role.type) {
                    case Constants.ROOT:
                    case Constants.ADMIN:
                        setRole(Constants.ADMIN);
                        setPanel(Constants.ADMIN);
                        localStorage.setItem('panel', Constants.ADMIN);
                        break;
                    case Constants.CASHIER:
                        setRole(Constants.CASHIER);
                        setPanel(Constants.CASHIER);
                        localStorage.setItem('panel', Constants.CASHIER);
                        break;
                    default:
                        setRole(Constants.CUSTOM);
                        setPanel(Constants.ADMIN);
                        localStorage.setItem('panel', Constants.ADMIN);
                        break;
                }
                setReady(true);
            }
        }).catch((error) => {
            setAuth(prev => {
                return {...prev, token: 'Unauthorized' }
            });
            setReady(false);
        });
    }

    return refresh;
}

export default useRefreshToken;